<!-- ADD-MODAL-STRUCTURE -->
<div class="master-modal success_popup" role="dialog">
  <div class="modal-dialog">
    <!-- Modal content-->
    <div class="modal-content">
      <!-- Modal-Header -->
      <div class="modal_close_btn">
        <span (click)="dialogClose()" class="modal-close"><i class="material-icons">close</i></span>
      </div>
      <!-- Modal content-->
      <div mat-dialog-content>
        <!-- Modal-Body -->
        <div class="modal-body br-8">
          <!-- <div class="modal_close_btn">
            <span (click)="dialogClose()" class="modal-close"><i class="material-icons">close</i></span>
          </div> -->
          <div class="select_profession_listing">
            <div class="custom-tabs">
              <!-- mat-tab-group -->
              <form class="form-section" [formGroup]="selectedForm" #msdsManageFormClear="ngForm">
                <h4 class="">Select Business Type</h4>
                <mat-tab-group [disableRipple]="true" [@.disabled]="true">
                  <!-- Dental Professional-TAB -->
                  <mat-tab class="specifications_tab" *ngFor="let busiType of data">
                    <ng-template mat-tab-label class="cstom_tab_label">
                      <!-- Dental Professional -->
                      {{busiType?.name}}
                    </ng-template>
                    <!-- TABS-BODY -->
                    <section class="tabs-body">
                      <ul>
                        <mat-radio-group aria-label="Select an option" formControlName="selEnterData" >
                          <li *ngFor="let busi of busiType?.directory_categories">
                            <mat-radio-button [value]="busi?.name" (click)="selectedData(busi)">{{busi?.name}}
                            </mat-radio-button>
                          </li>
                          <!-- <li>
                          <mat-radio-button value="Dental Therapist">Dental Therapist</mat-radio-button>
                        </li>
                        <li>
                          <mat-radio-button value="Dental Hygienist">Dental Hygienist</mat-radio-button>
                        </li>
                        <li>
                          <mat-radio-button value="Dental Technician">Dental Technician</mat-radio-button>
                        </li>
                        <li>
                          <mat-radio-button value="Dental Prosthetist">Dental Prosthetist</mat-radio-button>
                        </li>
                        <li>
                          <mat-radio-button value="Dental Student">Dental Student</mat-radio-button>
                        </li> -->
                        </mat-radio-group>
                      </ul>
                    </section>
                  </mat-tab>
                  <!-- Dental Specialist-TAB -->
                  <mat-tab class="specifications_tab">
                    <ng-template mat-tab-label class="cstom_tab_label">
                      Others
                    </ng-template>
                    <!-- TABS-BODY -->
                    <section class="tabs-body">
                      <ul>
                        <mat-radio-group aria-label="Select an option"  formControlName="selEnterData">
                          <li *ngFor="let busi of othersTypes?.directory_categories">
                            <mat-radio-button [value]="busi?.name" (click)="selectedData(busi)">{{busi?.name}}
                            </mat-radio-button>
                          </li>
                          <!-- <li>
                          <mat-radio-button value="">Dental assistant</mat-radio-button>
                        </li>
                        <li>
                          <mat-radio-button value="">Practice manager</mat-radio-button>
                        </li>
                        <li>
                          <mat-radio-button value="">Dental receptionist</mat-radio-button>
                        </li> -->
                          <!-- <li>
                          <mat-radio-button value="">Other</mat-radio-button> -->
                          <!-- Name-INPUT -->
                          <div class="custom-form-group mt-10">
                            <label class="custom_label">Others</label>
                            <div class="custom-form-control">
                                <mat-form-field appearance="outline">
                                  <input (ngModelChange)="selectedData(others.value)" matInput placeholder="Type here" formControlName="formData" #others>
                                  <!-- <mat-error *ngIf="name.invalid && ( name.dirty || name.touched )">
                                    <span>Please provide a valid value</span>
                                  </mat-error> -->
                              </mat-form-field>
                            </div>
                          </div>
                        </mat-radio-group>
                      </ul>
                    </section>
                  </mat-tab>
                </mat-tab-group>
                <div fxLayout="column" fxLayoutAlign="center center">
                  <button class="btn btn-sm global-btn" (click)="selMainData()" mat-button>Select</button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
